module.exports = __webpack_public_path__ + "media/images/university_logos/Queen-Mary-University-of-London-86b16738b0b881746f4822c5ae38d517.svg";